import classes from './MenuLogo.module.css'
import * as PathRouter from '../../models/PathRoute'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import * as ideWrapper from "../lms-shared/ide-wrapper";
import { onKeyDown } from '../../service';
import DynamicMessage from '../lms-shared/UI/Popups/DynamicMessage/DynamicMessage';
import { DynamicMessageTypeEnum } from '../lms-shared/models/DynamicMessageTypeEnum';


const MenuLogo = ({ setShowLogoMenu = { setShowLogoMenu } }) => {
    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const studyGroup = useSelector(state => state.topics.studyGroup);
    const [message, setMessage] = useState()
    const navigate = useNavigate();
    const location = useLocation()

    function goBackWithoutSave(url) {
        setMessage(null)
        navigate(url)
    }

    function clickItem(url) {
        const locationSplit = location.pathname.split('/')
        if (`/${locationSplit[1]}` === homeUrl && locationSplit[3] === PathRouter.PROJECT)
            ideWrapper.requestChangesProject((changed) => {
                if (changed == true) {
                    setMessage(<DynamicMessage
                        type={DynamicMessageTypeEnum.Warn}
                        title={texts.notSavedProject}
                        content={texts.messageContentSaveProjectAndExit}
                        cancelFunc={() => setMessage(null)}
                        confirmText={texts.save}
                        confirmFunc={() => setMessage(null)}
                        otherText={texts.exitWithoutSaving}
                        otherFunc={() => goBackWithoutSave(url)}
                        customWidth='430px' />)
                }
                else
                    setMessage(<DynamicMessage
                        type={DynamicMessageTypeEnum.Warn}
                        title={texts.exitIde}
                        cancelFunc={() => setMessage(null)}
                        confirmText={texts.exit}
                        confirmFunc={() => goBackWithoutSave(url)} />)
            })
        else
            navigate(url)
    }

    return (
        <>
            <div className={classes.MenuLogo}>
                <div className={classes.HighTechLogoContainer} onClick={() => setShowLogoMenu(false)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowLogoMenu(false))}>
                    <div className={classes.HighTechLogo}></div>
                    <div className={classes.CloseIcon} ></div>
                </div>
                <div className={classes.MenuContainer} >
                    <div className={classes.NavigateTo}>{texts.goTo}</div>
                    <button className={classes.MenuItem} onClick={() => clickItem(studyGroup ? `${homeUrl}/${studyGroup.id}/${PathRouter.DASHBOARD}` : homeUrl)}>{texts.actionBarDashboard}</button>
                    {studyGroup && <>
                        <button className={classes.MenuItem} onClick={() => clickItem(`${homeUrl}/${studyGroup.id}/${PathRouter.ASSESSMENTS}`)}>{texts.lessonsScreen}</button>
                        <button className={classes.MenuItem} onClick={() => clickItem(`${homeUrl}/${studyGroup.id}/${PathRouter.PROJECTS}`)}>{texts.DraftScreen}</button>
                    </>}
                </div>
            </div>
            {message}
        </>
    )
}
export default MenuLogo